<achoo-placeholder placeholderId="createNewGroupPlaceholder">
  <form #craeteGroupForm="ngForm" class="create-group-form d-flex" novalidate (ngSubmit)="createOrUpdateGroup()">
    <div class="create-group d-flex flex-column flex-auto" *ngIf="isShowCreateGroupForm">
      <div class="create-group-buttons bottombar-buttons">
        <button class="button green pull-right" type="submit">{{saveGroupButtonLabel}}</button>
        <button class="button red pull-right close-btn" (click)="cancelCreateOrUpdateGroup()">{{'common.btn.close' | translate}}</button>
      </div>
      <div class="create-group-from bottombar-content form-content flex-auto">
        <div class="row">
          <div class="col-lg-6 col-md-12 col-sm-12">
            <div class="group-info material-field">
              <achoo-material-input label="{{'group_influencers.group_name' | translate}}"
                                    placeholder="{{'group_influencers.group_name_placeholder' | translate}}"
                                    name="group_name"
                                    [(model)]="groupName">
              </achoo-material-input>
            </div>
            <div class="group-info material-field desc-field">
              <achoo-material-textarea [numberCol]="3"
                                       [(model)]="groupDescription"
                                       label="{{'group_influencers.description' | translate}}"
                                       placeholder="{{'group_influencers.description_placeholder' | translate}}">
              </achoo-material-textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</achoo-placeholder>



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/create-group-fragment/create-group-fragment.component.html